import styled, {css} from "styled-components";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";
import ProdImage from "@PUBLIC/P/images/ico/ico_prod.png";

const PopupContainer = styled.aside<{open?: boolean; show?: boolean}>`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 101;
	width: 100%;
	height: 100%;

	${props =>
		props.open
			? `
		display: block;
		`
			: `
		display: none;
		`}
	${props =>
		props.show
			? `
	
	> div {
			&:first-of-type{
				
				animation: dimmfadein 0.3s forwards;
				display: block;
			}
			&:last-of-type{
				animation: slidein 0.3s 0.3s forwards;
			}
	`
			: `
			> div {
			&:first-of-type{
				animation: dimmfadeout 0.3s forwards;
			}
			&:last-of-type{
				animation: slideout 0.3s forwards;
			}
	`}

	
	@keyframes dimmfadein {
		from {
			opacity: 0;
			height: 100%;
		}

		to {
			opacity: 1;
		}
	}
	@keyframes dimmfadeout {
		from {
			opacity: 1;
		}

		to {
			opacity: 0;
		}
	}

	@keyframes slidein {
		from {
			transform: translate3d(100%, 0, 0);
		}

		to {
			transform: translate3d(0, 0, 0);
		}
	}
	@keyframes slideout {
		from {
			transform: translate3d(0, 0, 0);
		}

		to {
			transform: translate3d(100%, 0, 0);
		}
	}
`;

const PopupDimm = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	z-index: 100;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
	opacity: 0;
	transition: opacity 0.3s;
	will-change: opacity;
`;

const PopupBlock = styled.div<{open?: boolean}>`
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	z-index: 100;
	display: flex;
	flex-direction: column;
	width: 400px;
	height: 100%;
	margin: 0;
	background: #fff;
	transform: translate3d(100%, 0, 0);
	transition: transform 0.3s;
	transition-timing-function: ease-in-out;
	will-change: transform;
	box-sizing: border-box;
`;

const PopupTop = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex: 0 0 70px;
	margin: 0 20px;
	border-bottom: 1px solid #222;
	box-sizing: border-box;
	> div {
		display: flex;
		align-items: center;
		gap: 15px;
		> button:first-of-type {
			min-width: 80px;
			+ button {
				margin: 0;
			}
		}
	}
`;

const PopupArea = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1 1 auto;
	height: calc(100% - 70px);
	overflow-x: hidden;
	overflow-y: auto;
`;

const TxtEmpty = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	text-align: center;
`;

const Title = styled.h3`
	display: -webkit-box;
	padding-right: 30px;
	font-size: 22px;
	color: var(--emp-color);
	letter-spacing: 0;
	font-family: "PT-medium";
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: normal;
	word-wrap: break-word;
	word-break: break-all;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	line-clamp: 1;

	> span {
		margin-left: 10px;
		font-size: 16px;
		font-weight: normal;
		color: var(--blue-color);
	}
`;

const TopArea = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex: 0 0 80px;
	width: 100%;
	height: 80px;
	padding: 0 20px;
	box-sizing: border-box;
	color: var(--emp-color);
	> span {
		font-size: 14px;
	}
	> button {
		background: #fff;
		font-size: 14px;
		text-decoration: underline;
		color: var(--emp-color);
	}
`;

const HistoryList = styled.ul`
	position: relative;
	display: flex;
	flex-direction: column;
	flex: 1 1 auto;
	padding: 0 20px;

	> li {
		flex: 0 0 auto;
		margin-top: -5px;
	}

	&:before {
		position: absolute;
		top: 0;
		left: 24px;
		z-index: 1;
		display: block;
		width: 2px;
		height: 100%;
		background: #ddd;
		content: "";
	}
`;

const TitDate = styled.p`
	position: relative;
	padding-left: 20px;
	margin-bottom: 30px;
	color: #222;
	&:before {
		position: absolute;
		top: 3px;
		left: 0;
		z-index: 2;
		display: inline-block;
		width: 11px;
		height: 11px;
		border-radius: 50%;
		background: #222;
		content: "";
	}
`;

const ProdList = styled.ul`
	display: flex;
	flex-direction: column;
`;

const ProdListItem = styled.li<{soldout?: boolean}>`
	position: relative;
	padding-left: 20px;
	margin-bottom: 30px;

	${props =>
		props.soldout &&
		`
		> div:first-of-type {
			display: flex;
		}
	`}
`;

const Prod = styled.div`
	display: flex;
	gap: 20px;
	overflow: hidden;
	cursor: pointer;
`;

const ArrowIcon = styled.i`
	display: inline-block;
	width: 16px;
	height: 12px;
	margin-right: 5px;
	background: url(${SpriteImage}) no-repeat -249px 0;
	background-size: 400px 400px;
`;

const ProdData = styled.div`
	position: absolute;
	top: 0;
	left: 20px;
	width: calc(100% - 20px);
	height: 100%;
	cursor: pointer;
`;

const ContainerTag = styled.div`
	position: relative;
	display: flex;
	justify-content: space-between;
	> div {
		position: absolute;
		top: 0;
		right: 0;
		z-index: 1;
		display: flex;
		align-items: center;
		gap: 20px;
	}
`;

const ProdDeleteBtn = styled.button`
	position: relative;
	width: 12px;
	height: 12px;
	background: transparent;
	&:before {
		position: absolute;
		top: 0;
		left: 50%;
		display: block;
		width: 1px;
		height: 12px;
		background: #7b7b7b;
		transform: rotate(-45deg) translateX(-50%);
		content: "";
	}
	&:after {
		position: absolute;
		top: 0;
		right: 50%;
		display: block;
		width: 1px;
		height: 12px;
		background: #7b7b7b;
		transform: rotate(-135deg) translateX(-50%);
		content: "";
	}
	> span {
		font-size: 0;
		text-indent: -9999em;
	}
`;

const ThumbImg = styled.span<{types?: string}>`
	position: relative;
	flex: 0 0 auto;
	width: 120px;
	height: 80px;
	overflow: hidden;

	${props => {
		if (props.types === "rent") {
			return css`
				display: flex;
				align-items: center;
				justify-content: center;
				background: #f3f3f3;
				&::before {
					display: block;
					z-index: 1;
					width: 63px;
					height: 50px;
					background: #f3f3f3 url(${ProdImage}) no-repeat 0 0;
					background-size: auto 50px;
					content: "";
				}
			`;
		}
		if (props.types === "air") {
			return css`
				display: flex;
				align-items: center;
				justify-content: center;
				background: #f3f3f3;
				&::before {
					display: block;
					z-index: 1;
					width: 67px;
					height: 50px;
					background: #f3f3f3 url(${ProdImage}) no-repeat -63px 0;
					background-size: auto 50px;
					content: "";
				}
			`;
		}
	}}

	img {
		width: 120px;
		height: 80px;
		object-fit: cover;
	}
`;

const ListView = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	flex: 1 1 auto;
	width: 200px;
`;

const BoxSoldout = styled.div`
	position: absolute;
	top: 0;
	left: 20px;
	z-index: 4;
	display: none;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 10px;
	width: calc(100% - 20px);
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
	color: #fff;

	> div {
		display: flex;
		gap: 8px;

		> button {
			width: 100px;
			padding: 10px 0;
			border: 1px solid #fff;
			background: transparent;
			color: #fff;
		}
	}
`;

const TitProd = styled.h5`
	display: -webkit-box;
	width: 180px;
	height: 44px;
	line-height: 22px;
	margin-top: 10px;
	font-size: 15px;
	color: var(--emp-color);
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
`;

const BoxInfo = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 20px;
	gap: 7px;

	> span {
		font-size: 14px;
		color: #555;
	}
`;

const AirIcon = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 5px;
`;

const DefinitionList = styled.dl<{types?: "basic" | "bar"}>`
	display: flex;
	align-items: center;
	text-align: left;
	line-height: 1.2;
	font-size: 14px;

	dt {
		position: relative;
		display: inline-flex;
		align-items: center;
		flex: 0 0 auto;
		padding-right: 10px;
		color: #222;
		vertical-align: middle;
	}
	dd {
		display: inline-block;
		color: #555;
		vertical-align: middle;
	}

	${props =>
		props.types === "bar" &&
		css`
			dt {
				padding-right: 0;
				&:after {
					display: inline-block;
					width: 1px;
					height: 10px;
					margin-left: 10px;
					background-color: #ddd;
					content: "";
				}
			}
			dd {
				margin-left: 10px;
			}
		`}
`;

const BtnArea = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 100px;
	> button {
		min-width: 140px;
	}
`;

export {
	AirIcon,
	ArrowIcon,
	BoxInfo,
	BoxSoldout,
	BtnArea,
	ContainerTag,
	DefinitionList,
	HistoryList,
	ListView,
	PopupArea,
	PopupBlock,
	PopupContainer,
	PopupDimm,
	PopupTop,
	ProdDeleteBtn,
	ProdList,
	ProdListItem,
	Prod,
	ProdData,
	TxtEmpty,
	ThumbImg,
	TitDate,
	TitProd,
	Title,
	TopArea,
};
